// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"9cc8f896","132":"4b7008e2","271":"cc9d07da","279":"572e39ff","319":"44df1d1f","449":"58b1ce6c","728":"6a06b1c6","748":"7cd8b481","798":"00dfd300","897":"3cfa0b84"}[chunkId] + ".chunk.js";
};